import { getAnalytics, logEvent } from "firebase/analytics";
import { app } from "../firebase";

let analytics = null;
const DEFAULT_APP_SURFACE = "sink";

export const initAnalytics = () => {
  if (typeof window !== "undefined" && !analytics) {
    try {
      analytics = getAnalytics(app);
      console.log("GA4 Initialized");
    } catch (e) {
      console.warn("Failed to initialize GA4:", e);
    }
  }
  return analytics;
};

export const getAnalyticsInstance = () => analytics;

/**
 * Standardized event tracking with safety checks
 * @param {string} name - Event name (GA4 standard if possible)
 * @param {Object} params - Event parameters. Must include 'surface'
 */
export const trackEvent = (name, params = {}) => {
  if (typeof window === "undefined") return;

  // Safety check: opt-out
  try {
    if (localStorage.getItem("secondBrain.analyticsOptOut") === "true") {
      return;
    }
  } catch {
    // Ignore localStorage errors
  }

  if (analytics) {
    try {
      logEvent(analytics, name, {
        ...params,
        app_surface: params.app_surface ?? DEFAULT_APP_SURFACE
      });
    } catch (e) {
      console.warn("Failed to log GA4 event:", e);
    }
  }
};

/**
 * Page view tracking
 * @param {string} pageName
 * @param {string} surface - 'lp' | 'demo' | 'app'
 */
export const trackPageView = (pageName, surface) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_path: window.location.pathname,
    surface: surface
  });
};
